import * as React from 'react';
import { TextInput } from '@box/blueprint-web';
import { REGEX_INTEGER, REGEX_NATURAL_NUMBER } from '../../../constants';
import isValidDigits from '../../utils/isValidDigits';

type NumberInputProps = {
  dataTestid?: string;
  disabled?: boolean;
  error?: React.ReactNode;
  inputType?: 'integer' | 'natural';
  label?: React.ReactNode;
  onChange: (...args: unknown[]) => unknown;
  placeholder?: string;
  required?: boolean;
  value: string;
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  [key: string]: any; // Allows us to pass "rest" props (useful for native HTML props for input element)
};

/*
  Component that handles number input
*/
const NumberInput = ({
  value,
  label,
  onChange,
  error,
  required,
  dataTestid,
  disabled = false,
  inputType = 'integer',
  placeholder,
  ...restProps
}: NumberInputProps) => {
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  const handleChange = (e: any) => {
    const inputValue = e.target.value;
    const regex =
      inputType === 'integer' ? REGEX_INTEGER : REGEX_NATURAL_NUMBER;
    if (regex.test(inputValue) && isValidDigits(inputValue)) {
      onChange(inputValue);
    }
  };

  return (
    <TextInput
      data-testid={dataTestid}
      disabled={disabled}
      error={error}
      inputMode="numeric"
      label={label}
      onChange={handleChange}
      placeholder={placeholder}
      required={required}
      value={value}
      /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
      {...(restProps as any)}
    />
  );
};

export { NumberInput };
export default NumberInput;
